<evc-platform
    [inputAppIdentification]="appIdentification()"
    [inputHelpMenu]="helpMenu()"
    [inputLeftBar]="leftbarConfig()"
    [inputSettingsMenu]="settingsMenu()"
  >
  <router-outlet />
</evc-platform>
